import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
const logo = process.env.PUBLIC_URL + '/images/kbl_logo.png'

const Welcome = () => {
  const { isAuthenticated, isStaff, loading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!loading) {
      if (isAuthenticated) {
        if (isStaff) {
          navigate('/surveys', { replace: true })
        } else {
          navigate('/operations', { replace: true })
        }
      } else {
        navigate('/login', { replace: true })
      }
    }
  }, [isAuthenticated, isStaff, loading, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-kbl-primary to-kbl-secondary">
      <div className="text-center">
        <img src={logo} alt="KBL Logo" className="mx-auto h-32 mb-8" />
        <h1 className="text-4xl font-bold text-white mb-4">Welcome to KBL Survey Management</h1>
        <p className="text-white/80 text-lg">Loading...</p>
      </div>
    </div>
  )
}

export default Welcome

